import {
  AllYouCanEatType,
  HistoryFlagType,
  IMenu,
  IMenuItemInfo,
  ITimeFrame,
  MenuBookGroupInfoType,
  ThInfoType,
} from 'apis/types';
import { MENU_DISPLAY_CONDITION } from 'constants/menuTiming';
import { CartStateData } from 'models';
import { attrLang, getErrorMessage } from 'utils';
import { DisplayTimingGroupSubmitResults } from 'utils/displayTimingGroup';

export const isMenuTimeControlInvalidForSubmit = (
  menu: IMenuItemInfo,
  displayTimingGroupSubmitResults: DisplayTimingGroupSubmitResults
): boolean =>
  menu.dispcond === MENU_DISPLAY_CONDITION.TIME_CONTROL &&
  menu.display_timing_group_id != null &&
  displayTimingGroupSubmitResults[String(menu.display_timing_group_id)] === false;

export const checkInValidItemInCart = (
  cartState: CartStateData,
  menuList: IMenu,
  thMenuInfo: ThInfoType,
  timeFrame: ITimeFrame,
  historyFlag: HistoryFlagType,
  allYouCanEatState: AllYouCanEatType,
  currentMenubook: MenuBookGroupInfoType | undefined,
  outOfStockItems: string[],
  haveAdult: number,
  timeFrameLunch: string[],
  displayTimingGroupSubmitResults: DisplayTimingGroupSubmitResults,
  timeControlUnavailableMessage: string
) => {
  let invalidItemName = '';
  let errorMessage = '';

  Object.keys(cartState).some((dishKey) => {
    const [, dishCode] = JSON.parse(dishKey);
    const dishInfo = menuList[dishCode];
    if (!dishInfo) return false;
    const outOfStocked = outOfStockItems.includes(dishInfo.poscd);

    let message = currentMenubook
      ? getErrorMessage(
          thMenuInfo.code,
          timeFrameLunch.includes(timeFrame.time_frame_id),
          historyFlag,
          allYouCanEatState,
          dishInfo,
          currentMenubook,
          outOfStocked,
          dishInfo.eos_flg,
          haveAdult
        )
      : '';

    if (!message && isMenuTimeControlInvalidForSubmit(dishInfo, displayTimingGroupSubmitResults)) {
      message = timeControlUnavailableMessage;
    }

    if (message) {
      invalidItemName = attrLang(dishInfo, 'lang');
      errorMessage = message;
    }

    return !!message;
  });

  return { invalidItemName, errorMessage };
};
